import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SupportTicket,
  SupportTicketAttachment,
  SupportTicketComment,
  SupportTicketDetails,
  SupportTicketStatusUpdate
} from '../models/support-ticket';
import { EndpointsService } from './endpoints.service';

@Injectable({
  providedIn: 'root'
})
export class SupportTicketService {

  constructor(
    private http: HttpClient,
    private endpointService: EndpointsService
  ) { }

  getTickets(includeAll = false): Observable<SupportTicket[]> {
    const options = includeAll
      ? { ...this.endpointService.httpOptions, params: new HttpParams().set('all', 'true') }
      : this.endpointService.httpOptions;

    return this.http.get<SupportTicket[]>(this.endpointService.supportTickets, options);
  }

  createTicket(ticket: SupportTicket): Observable<SupportTicket> {
    return this.http.post<SupportTicket>(
      this.endpointService.supportTickets,
      ticket,
      this.endpointService.jsonHttpOptions
    );
  }

  getTicketDetails(ticketId: number): Observable<SupportTicketDetails> {
    return this.http.get<SupportTicketDetails>(
      `${this.endpointService.supportTickets}/${ticketId}`,
      this.endpointService.httpOptions
    );
  }

  updateTicketStatus(ticketId: number, request: SupportTicketStatusUpdate): Observable<SupportTicket> {
    return this.http.patch<SupportTicket>(
      `${this.endpointService.supportTickets}/${ticketId}/status`,
      request,
      this.endpointService.jsonHttpOptions
    );
  }

  addComment(ticketId: number, comment: string): Observable<SupportTicketComment> {
     const body: SupportTicketComment = { comment: comment?.trim() ?? '' };

    return this.http.post<SupportTicketComment>(
      `${this.endpointService.supportTickets}/${ticketId}/comments`,
      body,
      this.endpointService.jsonHttpOptions
    );
  }
  //TODO TO REMOVE
  addAttachment(ticketId: number, attachment: SupportTicketAttachment): Observable<SupportTicketAttachment> {
    return this.http.post<SupportTicketAttachment>(
      `${this.endpointService.supportTickets}/${ticketId}/attachments`,
      attachment,
      this.endpointService.jsonHttpOptions
    );
  }


  addAttachments(
    ticketId: number,
    files: File[],
    initialCreation = false
  ): Observable<SupportTicketAttachment[]> {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files', file, file.name);
    });

    return this.http.post<SupportTicketAttachment[]>(
      `${this.endpointService.supportTickets}/${ticketId}/attachments`,
      formData,
      {
        ...this.endpointService.httpOptions,
        params: new HttpParams().set('initialCreation', String(initialCreation))
      }
    );
  }

  downloadAttachment(ticketId: number, attachmentId: number): Observable<Blob> {
    return this.http.get<Blob>(
      `${this.endpointService.supportTickets}/${ticketId}/attachments/${attachmentId}`,
      {
        ...this.endpointService.httpOptions,
        responseType: 'blob' as 'json'
      }
    );
  }

  removeAttachment(ticketId: number, attachmentId: number): Observable<void> {
    return this.http.delete<void>(
      `${this.endpointService.supportTickets}/${ticketId}/attachments/${attachmentId}`,
      this.endpointService.httpOptions
    );
  }
}
